import { Axios, AxiosError } from 'axios';
import fs from 'fs';
import fsp from 'fs/promises';
import FormData from 'form-data';
import { InitialScan } from './generated';
import virusScannerConfig from './config';

export async function uploadFile(
  scanRequest: InitialScan,
  fileToUpload: string,
  axios: Axios | undefined = undefined,
): Promise<void> {
  let axiosInstance = axios;

  if (axiosInstance === undefined) {
    axiosInstance = new Axios({ maxBodyLength: virusScannerConfig.maxUploadSize });
  }

  const stats = await fsp.stat(fileToUpload);
  const fileStream = fs.createReadStream(fileToUpload);
  const data = new FormData();

  for (const key of Object.keys(scanRequest.s3.fields)) {
    const value = scanRequest.s3.fields[key];
    data.append(key, value);
  }

  data.append('file', fileStream, {
    knownLength: stats.size,
  });

  const axiosResponse = await axiosInstance
    .post(scanRequest.s3.url, data, {
      headers: {
        ...data.getHeaders(),
        'Content-Length': data.getLengthSync(),
      },
    })
    .catch((error: AxiosError) => {
      const { code } = error;
      if (code === 'ERR_FR_MAX_BODY_LENGTH_EXCEEDED') {
        const sizeInMB = virusScannerConfig.maxUploadSize / (1024 * 1024);
        throw new Error(`File size exceeds the maximum limit of ${sizeInMB}MB`);
      }
      throw error;
    });

  if (axiosResponse.status !== 204) {
    throw new Error('Error occurred uploading. http status ' + axiosResponse.status);
  }
}
